(function(){
  // Instant DOM sort
  window.czxSort = function(val) {
    var grid = document.getElementById('czx-prod-grid');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll('.czx-card'));

    cards.sort(function(a, b) {
      if (val === 'created-descending') {
        return (b.dataset.date || '').localeCompare(a.dataset.date || '');
      } else if (val === 'created-ascending') {
        return (a.dataset.date || '').localeCompare(b.dataset.date || '');
      } else if (val === 'price-ascending') {
        return parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0);
      } else if (val === 'price-descending') {
        return parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0);
      } else if (val === 'title-ascending') {
        return (a.dataset.title || '').localeCompare(b.dataset.title || '');
      } else if (val === 'title-descending') {
        return (b.dataset.title || '').localeCompare(a.dataset.title || '');
      }
      return 0;
    });

    cards.forEach(function(card) { grid.appendChild(card); });
  };

  // Custom sort dropdown wiring + auto-sort on load
  (function() {
    var dropdown   = document.getElementById('czx-col-sort-dropdown');
    var btn        = document.getElementById('czx-col-sort-btn');
    var list       = document.getElementById('czx-col-sort-list');
    var label      = document.getElementById('czx-col-sort-label');
    if (!dropdown || !btn || !list) return;

    var STORAGE_KEY = 'czx-col-sort-' + (window.location.pathname.split('/').filter(Boolean).pop() || 'collection');
    var DEFAULT_SORT = 'created-descending';

    // Restore persisted sort or fall back to newest-first
    var savedSort = sessionStorage.getItem(STORAGE_KEY) || DEFAULT_SORT;

    function applySort(val, persist) {
      // Update dropdown UI
      list.querySelectorAll('.czx-sort-option').forEach(function(o) {
        var isSelected = o.getAttribute('data-value') === val;
        o.classList.toggle('selected', isSelected);
        if (isSelected && label) label.textContent = o.textContent;
      });
      // Sort the grid
      czxSort(val);
      // Persist if user explicitly chose it
      if (persist) sessionStorage.setItem(STORAGE_KEY, val);
    }

    // Auto-apply on page load (handles both first visit and pagination)
    applySort(savedSort, false);

    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = dropdown.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen);
    });

    list.addEventListener('click', function(e) {
      var opt = e.target.closest('.czx-sort-option');
      if (!opt) return;
      dropdown.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      applySort(opt.getAttribute('data-value'), true);
    });

    document.addEventListener('click', function() {
      dropdown.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    });
  })();

  // Notify me form (swappable with Klaviyo)
  window.czxNotifySubmit = function(e) {
    e.preventDefault();
    var email = document.getElementById('czx-notify-email').value;
    // ── Replace below with your Klaviyo / email list signup API call ──
    // Example: fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {...})
    console.log('Notify signup:', email);
    document.getElementById('czx-cs-form-wrap').querySelector('form').style.display = 'none';
    document.getElementById('czx-notify-msg').style.display = 'block';
  };
})();